import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { authService } from '../services/authService';
import { toast } from 'react-toastify';
import 'admin-lte/dist/css/adminlte.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const ForgotPassword: React.FC = () => {
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            Email: ''
        },
        validationSchema: Yup.object({
            Email: Yup.string()
                .email('Geçerli bir email adresi giriniz')
                .required('Email adresi zorunludur')
        }),
        onSubmit: async (values) => {
            try {
                await authService.forgotPassword({ Email: values.Email });
                toast.success('Şifre sıfırlama bağlantısı email adresinize gönderildi.');
                navigate('/login');
            } catch (error) {
                toast.error('Bir hata oluştu. Lütfen tekrar deneyiniz.');
            }
        },
    });

    return (
        <div className="hold-transition login-page">
            <div className="login-box">
                <div className="login-logo">
                    <b>Yapi</b>CRM
                </div>

                <div className="card">
                    <div className="card-body login-card-body">
                        <p className="login-box-msg">Şifrenizi mi unuttunuz?</p>

                        <form onSubmit={formik.handleSubmit}>
                            <div className="mb-3">
                                <div className="input-group">
                                    <input
                                        type="email"
                                        className={`form-control ${formik.touched.Email && formik.errors.Email ? 'is-invalid' : ''}`}
                                        placeholder="Email"
                                        {...formik.getFieldProps('Email')}
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-envelope"></span>
                                        </div>
                                    </div>
                                </div>
                                {formik.touched.Email && formik.errors.Email && (
                                    <div className="invalid-feedback d-block">{formik.errors.Email}</div>
                                )}
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={formik.isSubmitting}
                                    >
                                        {formik.isSubmitting ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            'Şifre Sıfırlama Bağlantısı Gönder'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>

                        <p className="mt-3 mb-1">
                            <Link to="/login" className="text-center">
                                Giriş sayfasına dön
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;